import { mapStores } from 'pinia'
import useBcSelectedStore from '@/frontapp/store/bcSelected'
import useBcBookmarkStore from '@/frontapp/store/bcBookmark'
import useBcFolderStore from '@/frontapp/store/bcFolder'

export default {
  props: {
    item: Object,
    rank: Number,
    draggable: Boolean,
  },
  computed: {
    previews() {
      if (this.item.calcPreviews) {
        return this.item.calcPreviews
      }

      return this.item.previews
    },
    bookmarked() {
      return this.bcBookmarkStore.isBookmarked(this.item)
    },
    notPublished() {
      return this.item.type === 'document' && !this.item.published__bc_document_rev_id
    },
    infoClass() {
      let cnt = 0
      if (this.item.hidden) {
        cnt++
      }

      if (this.bookmarked) {
        cnt++
      }

      if (this.item.type === 'document' && !this.item.published__bc_document_rev_id) {
        cnt++
      }

      if (cnt === 2) {
        return '!w-12'
      } else if (cnt === 3) {
        return '!w-16'
      }

      return null
    },
    dragEnabled () {
      return this.draggable
        && this.bcFolderStore.current?.can_edit
        && this.bcFolderStore.order === 'rank'
        && this.bcFolderStore.show === 'bc'
        && this.bcFolderStore.trashBin === false
    },
    ...mapStores(useBcSelectedStore, useBcBookmarkStore, useBcFolderStore),
  },
  methods: {
    open() {
      this.$refs.link.click();
    }
  }
}